import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useWorkItemStore } from '../store/useWorkItemStore';
import { useAppStore } from '../store/useAppStore';
import TaskListView from '../components/tasks/TaskListView';
import RefreshButton from '../components/common/RefreshButton';

export default function ListPage({ projectId: scoped }: { projectId?: string } = {}) {
  const params = useParams<{ projectId: string }>();
  const projectId = scoped || params.projectId;
  const { selectedProjectId, setSelectedProject } = useAppStore();
  const { fetchByProject } = useWorkItemStore();

  const activeProjectId = projectId || selectedProjectId;

  useEffect(() => {
    if (activeProjectId) {
      setSelectedProject(activeProjectId);
      fetchByProject(activeProjectId);
    }
  }, [activeProjectId, setSelectedProject, fetchByProject]);

  if (!activeProjectId) {
    return (
      <div className="flex items-center justify-center h-full text-gray-400">
        <p>Select a project to view the list</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center justify-between px-4 py-2 border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shrink-0">
        <span className="text-sm font-semibold text-gray-700 dark:text-gray-300">List View</span>
        <RefreshButton
          onRefresh={async () => { if (activeProjectId) await fetchByProject(activeProjectId); }}
          tooltip="Refresh list data"
        />
      </div>
      <TaskListView />
    </div>
  );
}
